import { render, staticRenderFns } from "./CommonLayoutComponent2.vue?vue&type=template&id=6d32145c&scoped=true&"
import script from "./CommonLayoutComponent2.vue?vue&type=script&lang=js&"
export * from "./CommonLayoutComponent2.vue?vue&type=script&lang=js&"
import style0 from "./CommonLayoutComponent2.vue?vue&type=style&index=0&id=6d32145c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d32145c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d32145c')) {
      api.createRecord('6d32145c', component.options)
    } else {
      api.reload('6d32145c', component.options)
    }
    module.hot.accept("./CommonLayoutComponent2.vue?vue&type=template&id=6d32145c&scoped=true&", function () {
      api.rerender('6d32145c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/commons/CommonLayoutComponent2.vue"
export default component.exports